export default {
  title: 'Download de {{app}}-app',
  qr_code_desc: 'Scan deze QR-code met je telefoon om de app te downloaden',
  cta: 'Download de app en meld je aan voor {{amount}} cashback!',
  download_from: 'Of download via:',
  direct_link: 'Directe link:',
};
